import { defineComponent, ref, reactive } from 'vue'
import OrderAddress from '../order-address/index'
import {hostForImage, imageOldSite} from '@/const'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import './style.sass'

export default defineComponent({
  props: {
    ordersItems: {
      type: Array,
      default: () => []
    }
  },
  setup (props: any) {

    const showAllOrderInfo = ref({ active: false, id: 0 })

    function showAllInfo (id: number) {
      showAllOrderInfo.value.active = true
      showAllOrderInfo.value.id = id
    }

    function getDateOrder (val: string) {
      return dayjs(val).locale('ru').format('D MMM')
    }

    function getDeliveryOrder (val: string) {
      return dayjs(val).locale('ru').format('D MMM YYYY')
    }

    function statusFilter (val: any) {
      if (!val) return
      return val.filter((item: any) => item.status.name === 'payment').length > 0;
    }

    return () => {
      return (
        <div class="orders-items">
          {props.ordersItems.length > 0 ? (
            props.ordersItems.map((item: any, id: number) => (
              <div class="orders-item">
                <a href={`/order?orderId=${item.number}`} onClick={() => {
                  // @ts-ignore
                  ym(100581,'reachGoal','orderLkSee')
                }}>
                  <div class="orders-item-top">
                    <div class="orders-item-top-name">
                      <span>Заявка от {getDateOrder(item.basicInvoice?.createdAt)}</span>
                      <span>{`Заявка №${item.number}`}</span>
                      <span>{item.basicInvoice ? `к счету № ${item.basicInvoice.number}` : ''}</span>
                    </div>

                    <div>
                      {item.company ? (
                        <div class="orders-item-top-company">
                          <span>{item.company.name}</span>
                          <span>{`ИНН - ${item.company.inn}`}</span>
                        </div>
                      ) : null }
                    </div>

                    <div class="orders-item-content-top-statuses">
                      {item.status !== "CANCELLED" && item.status !== "FINISH"
                        ? (
                          <div>
                            {item.status === "IN_PROGRESS"
                              ? (<div class="order-status-in-progress">В работе</div>)
                              : null
                            }
                            {item.basicInvoice?.payment == item.basicInvoice?.totalCost && item.basicInvoice?.totalCost != 0 && item.basicInvoice?.manager
                              ? (<div class="orders-item-top-status">Оплачено</div>)
                              : null
                            }
                            {!item.basicInvoice?.payment && item.basicInvoice?.totalCost != 0 && item.basicInvoice?.manager
                              ? (<div class="orders-item-content-top-status-no-pay">Не оплачено</div>)
                              : null
                            }
                            {item.basicInvoice?.payment > 0 && item.basicInvoice?.payment < item.basicInvoice?.totalCost && item.basicInvoice?.manager
                              ?(<div class="orders-item-content-top-status-no-pay">Частичная оплата</div>)
                              : null
                            }
                            {item.basicInvoice?.payment > 0 && item.basicInvoice?.payment > item.basicInvoice?.totalCost && item.basicInvoice?.manager
                              ?(<div class="orders-item-content-top-status-no-pay">Переплата</div>)
                              : null
                            }
                            {item.basicInvoice?.logist && item.status !== "FINISH" && item.status !== "CANCELLED" && item.status !== "SPAM" ? (
                              <div class="order-status-delivery">
                                Доставка
                              </div>
                            ) : null}
                            {!item.transportCompanyTitle && !item.deliveryAddress && !item.basicInvoice?.logist
                              ? (<div class="order-status-delivery">Ожидает отправки</div>)
                              : null
                            }
                          </div>
                        )
                        : null
                      }
                      {item.status === "FINISH"
                        ? (<div class="order-status-delivered">Завершена</div>)
                        : null
                      }
                      {item.status === "CANCELLED"
                        ? (<div class="order-status-cancelled">Отменена</div>)
                        : null
                      }
                      {item.status === "SPAM"
                        ? (<div class="order-status-cancelled">Отменена / Спам </div>)
                        : null
                      }
                    </div>
                    <div class="orders-item-top-price">
                      <div class="orders-item-top-price-nds">с НДС</div>
                      <div class="orders-item-top-price-value">{`${item.basicInvoice ? item.basicInvoice.totalCost : 0} ₽`}</div>
                    </div>
                  </div>
                </a>

                <div class="orders-item-content">
                  <div class="orders-item-content-top">
                    { item.transportCompanyTitle && item.deliveryAddress ? (
                      <OrderAddress
                        delivery={item.transportCompanyTitle}
                        address={item.deliveryAddress}
                      />
                    ) : (
                      null
                      // TODO: Пока функционала по этой штуке нету. Так что скроем временно
                      // <div class="orders-item-content-top-text">
                      //   <img src={require('@/assets/message-error-icon.svg')} />
                      //   <p>Указать способ получения товара</p>
                      // </div>
                    )}
                    {/* Ниже два статуса, которые были ранее в дизайне и потом их убрали,
                      могут понадобиться в дальнейшем */}
                    {/* <div class="orders-item-content-top-status">Доставляется</div> */}
                    {/* <div class="orders-item-content-bottom-info-button-stay-pay">Ожидается оплата</div> */}
                  </div>

                  <div class="orders-item-content-middle">
                    <img src={require('@/assets/calendar.svg')} />
                    <div class="orders-item-content-middle-description">
                      <p>Дата доставки: <span>{getDeliveryOrder(item.approximateDeliveryDate)}</span></p>
                    </div>
                    <div class="orders-item-content-middle-images">
                      {item.basicInvoice?.items.length > 0 ? (
                        item.basicInvoice?.items.map((element: any) => (
                          element.imageUrl ? (
                            <div class="orders-item-content-middle-images-content">
                              <img src={`${imageOldSite}/${element.imageUrl}`} />
                              <div class="orders-item-content-middle-images-count">{`x ${element.quantity}`}</div>
                            </div>
                          ) : (
                            <div class="orders-item-content-middle-images-content-no-img">
                              <img src={require('@/assets/no_image.svg')}  alt=""/>
                              <div class="orders-item-content-middle-images-count">{`x ${element.quantity}`}</div>
                            </div>
                            // item.basicInvoice?.logist && item.dateReceived ? (
                            //   <div>
                            //     <p>Доставлен</p>
                            //   </div>
                            // ) : null
                          )
                        ))) : null}
                    </div>
                  </div>

                  <div class="orders-item-content-bottom">
                    { !showAllOrderInfo.value.active || showAllOrderInfo.value.id !== id ? (
                      <div class="orders-item-content-bottom-info-button" onClick={() => showAllInfo(id)}>Подробнее</div>
                    ) : null}
                    {item.basicInvoice ?
                      (<a target="_blank" href={`${hostForImage}${item.basicInvoice.file?.path}`} class="download-invoice"
                          onClick={() => {
                            // @ts-ignore
                            ym(100581,'reachGoal','lkDownloadInvoice')
                          }}
                      >
                        <img class="order-bottom-file-download" src={require('@/assets/download.svg')}/> Скачать счёт
                      </a>)
                      : null
                    }
                    {/* Ниже кнопка, которая была ранее в дизайне и потом её убрали,
                      может понадобиться в дальнейшем */}
                    {/* <div class="orders-item-content-bottom-change-order-button">Изменить заявку</div> */}
                  </div>

                  {showAllOrderInfo.value.active && showAllOrderInfo.value.id === id ? (
                    <div class="orders-item-content-all-info">
                      {item.basicInvoice?.items.length > 0 ? (
                        <div>
                          <div class="orders-item-content-all-info-title">Состав заявки</div>
                          <div class="orders-item-content-all-info-elems">
                            {item.basicInvoice?.items.map((ordersElem: any) => (
                              <div class="orders-item-content-all-info-elem">
                                <div class="orders-item-content-all-info-elem-name">
                                  {ordersElem.product}
                                </div>
                                <div class="orders-item-content-all-info-elem-wrap" />
                                <div class="orders-item-content-all-info-elem-lenght">
                                  {`${ordersElem.quantity} ${ordersElem.unit} `}
                                </div>
                                <div class="orders-item-content-all-info-elem-price">
                                  {`${ordersElem.price} ₽`}
                                </div>
                                {item.basicInvoice?.logist && !ordersElem.dateReceived ? (
                                  <div class="orders-item-content-all-info-elem-delivery">
                                    Доставка
                                  </div>
                                ) : null}
                                {ordersElem.dateReceived && item.basicInvoice?.logist ? (
                                  <div class="orders-item-content-all-info-elem-delivered">
                                    Доставлен
                                  </div>
                                ) : null}
                              </div>
                            ))}
                          </div>
                          <div class="orders-item-content-all-info-hide">
                            <img src={require('../../assets/arrow.svg')} onClick={() => { showAllOrderInfo.value.active = false }}  alt=""/>
                            <span onClick={() => { showAllOrderInfo.value.active = false }}>скрыть</span>
                          </div>
                        </div>
                      ) : null }
                    </div>
                  ) : null}
                </div>
              </div>
            ))) : null}
        </div>
      )
    }
  }
})